<template>
  <div class="flex min-h-[64px] items-center gap-3 py-2">
    <Avatar :src="owner.avatarUrl" :size="32" class="shrink-0" />
    <div class="min-w-0 flex-1">
      <div class="truncate text-[14px] leading-[18px] text-gray-800">
        {{ owner.name }}
      </div>
      <div
        v-if="managedBy"
        class="truncate text-[13px] leading-[18px] text-gray-500"
      >
        Managed by {{ managedBy }}
      </div>
    </div>

    <Pill v-if="account">You</Pill>
    <div v-else class="flex items-center gap-1">
      <button
        type="button"
        aria-label="Edit"
        class="flex size-8 items-center justify-center rounded-[6px] text-gray-800 transition hover:bg-gray-800/6"
        @click="emit('edit')"
      >
        <PencilIcon class="size-[18px]" />
      </button>
      <button
        type="button"
        aria-label="Remove"
        class="flex size-8 items-center justify-center rounded-[6px] text-red-700 transition hover:bg-red-700/8"
        @click="emit('remove')"
      >
        <TrashIcon class="size-[18px]" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Avatar, Pill } from '@dacr/library'
import { PencilIcon, TrashIcon } from '@dacr/icons'
import type { CopyrightOwnerItem } from './useCopyrightOwners'

defineProps<{
  owner: CopyrightOwnerItem
  account: boolean
  managedBy: string
}>()

const emit = defineEmits<{
  (e: 'edit'): void
  (e: 'remove'): void
}>()
</script>
